export const ACTIVATE_MY_OFFERS = 'page/MY_OFFERS [activate]';
export const ACTIVATE_LOAN_BUILDER = 'page/LOAN_BUILDER [activate]';

export const MY_OFFERS_READY = 'page/MY_OFFERS [ready]';
export const MY_OFFERS_LOADING = 'page/MY_OFFERS [loading]';
export const LOAN_BUILDER_LOADING = 'page/LOAN_BUILDER [loading]';

export const MY_OFFERS_INPUT_ERROR = 'page/MY_OFFERS_INPUT_ERROR';

export const SHOW_DRAWDOWN_REPAYMENT_SCHEDULE_MODAL =
    'page/SHOW_DRAWDOWN_REPAYMENT_SCHEDULE_MODAL';

export const MY_OFFERS_REPAYMENT_SCHEDULE_MODAL_DATA =
    'page/MY_OFFERS_REPAYMENT_SCHEDULE_MODAL_DATA [done]';

export const MY_OFFERS_GET_DRAWDOWN_SCHEDULES =
    'page/MY_OFFERS_GET_DRAWDOWN_SCHEDULES';
export const MY_OFFERS_DRAWDOWN_SCHEDULES_READY =
    'page/MY_OFFERS_DRAWDOWN_SCHEDULES_READY [ready]';
export const MY_OFFERS_DRAWDOWN_SCHEDULES_LOADING =
    'page/MY_OFFERS_DRAWDOWN_SCHEDULES_LOADING';

export const GET_EARLY_REPAYMENT_BREAKDOWN =
    'page/GET_EARLY_REPAYMENT_BREAKDOWN';
export const SHOW_EARLY_REPAYMENT_BREAKDOWN =
    'page/SHOW_EARLY_REPAYMENT_BREAKDOWN';

export const SET_SELECTED_OFFER = 'page/SET_SELECTED_OFFER';
export const SET_DRAWDOWN_AMOUNT = 'page/SET_DRAWDOWN_AMOUNT';

export const REQUEST_DRAW_DOWN_REPAYMENT_SCHEDULE =
    'page/MULTI_FLEXI_LOAN_DRAW_DOWN_REPAYMENT_SCHEDULE [request]';

export const DEFERRED_APPLICATION_REAPPLY = 'DEFERRED_APPLICATION_REAPPLY';
export const DECLINED_APPLICATION_REAPPLY = 'DECLINED_APPLICATION_REAPPLY';
